var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidedPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_3369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.4682V16.7582",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00017 1.38798L9.00012 7.08293C7.20818 7.31573 5.49318 7.27339 3.72567 6.94981C3.54873 6.91742 3.3817 6.84492 3.24013 6.73629C2.51613 6.18078 1.90999 5.56506 1.41049 4.81755C1.17569 4.46617 1.18889 4.01216 1.432 3.66621C1.93024 2.95721 2.49791 2.3343 3.1607 1.76864C3.31227 1.63928 3.49753 1.55364 3.69548 1.51806C5.47236 1.1987 7.19845 1.15734 9.00017 1.38798Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.55973L9.00005 12.2547C10.792 12.4875 12.507 12.4451 14.2745 12.1216C14.4514 12.0892 14.6185 12.0167 14.7601 11.908C15.4841 11.3525 16.0902 10.7368 16.5897 9.9893C16.8245 9.63791 16.8113 9.18391 16.5682 8.83797C16.0699 8.12896 15.5022 7.50604 14.8394 6.94039C14.688 6.81103 14.5026 6.7254 14.3047 6.68982C12.5278 6.37046 10.8017 6.32909 9 6.55973Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_3369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidedPath);
export default __webpack_public_path__ + "static/media/guided_path.46f9c49bcb49bdf5115951e8ee8283bd.svg";
export { ForwardRef as ReactComponent };